import _ from 'lodash'
import Vue from 'vue'
import { DataTableHeader } from 'vuetify'
import { Recueil } from './models/Recueil'

export default Vue.extend({
    data() {
        return {
            companyName: '',
            dateDebut: `${new Date().getFullYear()}-01-01`,
            dateFin: '',
            recueil: [] as Recueil[],
            chirurgien : null as null | string,
            statut: ''
        }
    },
    computed: {
        headersRecueil(): DataTableHeader[] {
            return [
                { text: 'Chirurgien', value: 'chirurgien' },
                { text: 'Code tête', value: 'codeTeteFemorale' },
                { text: 'Date de prélèvement', value: 'datePrelevement' },
                { text: "Date d'arrivée", value: 'dateArrivee' },
                { text: 'Statut', value: 'etat', sort: (a, b) => (a?.statut ?? 'En attente').localeCompare(b?.statut ?? 'En attente') }
            ]
        },
        statutListe():  { text: string, value : string}[] {
            return [
                { text: 'En attente', value: 'En attente' },
                { text: 'Validé', value: 'Validé' },
                { text: 'Rebuté', value: 'Rebuté' },
                { text: 'Quarantaine', value: 'Quarantaine' }
            ]
        },
        chirurgienAutoComplete() : { text: string, value : string}[] {
            if (this.recueil.length) {
                return _.chain(this.recueil)
                    .uniqBy('codeChirurgien')
                    .map((r) => {
                        return {
                            text: r.chirurgien,
                            value: r.codeChirurgien
                        };
                    })
                    .value();
            }

            return []
        }, 
        recueilFiltered() : Recueil[] {
            if(!this.chirurgien && !this.statut) {
                return this.recueil
            }
            else if(!this.chirurgien && this.statut) {
                return _.filter(this.recueil, (r) => r.statut == this.statut)
            }
            else if(this.chirurgien && !this.statut) {
                return _.filter(this.recueil, (r) => r.codeChirurgien == this.chirurgien)
            }
 
            return  _.filter(this.recueil, (r) => r.codeChirurgien == this.chirurgien && r.statut == this.statut)
        }
    },
    methods: {
        formatDate(date: string) {
            if (!date) return ''
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        reloadDatatable() {
            if (!this.companyName) return

            this.$loader.go()

            return this.$http
                .api(`suiviRecueil`)
                .post({ name: this.companyName, dateDebut: this.formatDate(this.dateDebut), dateFin: this.formatDate(this.dateFin) })
                .then(x => {
                    this.recueil = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    }
})
